(function ($, root, undefined) {

  $(function () {

    'use strict';

    initSite();

    function initSite() {

      // $('body').addClass("onload");

      // console.log("INIT SITE");

      // create the smooth scroller
      let smoother = ScrollSmoother.create({
        smooth: 2,
        effects: true,
        normalizeScroll: true,
        // smoothTouch: 0,
      });

      // SLIDER LOGOS - (support multiple instances)

      $('.swiperLogos').each(function() {

        const $container = $(this);
        const swipId = $container.data('swip');

        new Swiper(this, {
          direction: 'horizontal',
          loop: true,
          slidesPerView: 4,
          spaceBetween: 60,

          // autoplay: {
          //  delay: 5000,
          // },

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          breakpoints: {
            320: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            760: {
              slidesPerView: 3,
              spaceBetween: 20
            },
            // when window width is >= 720px
            1040: {
              slidesPerView: 4,
              spaceBetween: 20
            },
            // when window width is >= 1280px
            1280: {
              slidesPerView: 5,
              spaceBetween: 20
            },
            // when window width is >= 1440px
            1440: {
              slidesPerView: 6,
              spaceBetween: 20
            }
          }
        });

      });

      // SLIDER LISTING - (support multiple instances)

      $('.swiperListing').each(function() {

        const $container = $(this);
        const itemId = $container.data('item');

        new Swiper(this, {
          direction: 'horizontal',
          loop: false,
          slidesPerView: 6,
          spaceBetween: 30,
          // centeredSlides: true,

          // Navigation spécifique à chaque instance
          navigation: {
            nextEl: '.swiper-button-next[data-item="' + itemId + '"]',
            prevEl: '.swiper-button-prev[data-item="' + itemId + '"]',
          },

          breakpoints: {
            320: {
              slidesPerView: 1,
              spaceBetween: 20
            },
            720: {
              slidesPerView: 2,
              spaceBetween: 60
            },
            940: {
              slidesPerView: 3,
              spaceBetween: 60
            },
            1280: {
              slidesPerView: 4,
              spaceBetween: 60
            },
            1720: {
              slidesPerView: 4,
              spaceBetween: 30
            }
          }
        });

      });

      // Toogle Navigation Mobile

      $('.nav').find('.menu-item-has-children').click(function(){
        $(".menu-item-has-children").not($(this)).removeClass('active');
        $(this).toggleClass('active');
      });

      // Toogle Button Navigation

      // $('.nav-button').click(function() {
      //   $('body').toggleClass('noScroll');
      //   smoother.paused(true);
      //   console.log("smother pause");
      // });

      document.querySelector(".nav-button").addEventListener("click", () => {
        $('body').toggleClass('noScroll');
        // toggle!
        smoother.paused(!smoother.paused());
        // console.log("smother pause");
      });

    }

    // AFTER INIT SITE

  });

})(jQuery, this);

// wait until DOM is ready
document.addEventListener("DOMContentLoaded", function(event){

  console.log("DOM loaded");
  console.clear();

  // https://gsap.com/docs/v3/Plugins/ScrollTrigger/

  // gsap.set(".colFlex", { autoAlpha: 0 });

  // ScrollTrigger.batch(".colFlex", {
  //   onEnter: (batch) =>
  //     gsap.to(batch, {
  //       duration: 1,
  //       autoAlpha: 1,
  //       y: 0,
  //       stagger: 0.1
  //     }),
  //   start: "top center"
  // });

});


(function($, undefined) {
    var isFired = false;
    var oldReady = jQuery.fn.ready;
    $(function() {
        isFired = true;
        $(document).ready();
    });
    jQuery.fn.ready = function(fn) {
        if(fn === undefined) {
            $(document).trigger('_is_ready');
            return;
        }
        if(isFired) {
            window.setTimeout(fn, 1);
        }
        $(document).bind('_is_ready', fn);
    };
})(jQuery);
